import GLightbox from 'glightbox';
import $ from "jquery";

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {
    if (inBackend) return;


    $('.lightbox').each(function () {

        const $lightbox = $(this);
        let elements = [];

        const $lightboxItems = $lightbox.find('.lightbox-item-link').filter(function () {
            // Filter out, if no src is given
            return !!$(this).data('src');
        });

        // Prepare contents from html tags
        $lightboxItems.each(function () {
            const src = $(this).data('src');
            const title = $(this).data('title') || null;
            const description = $(this).data('description') || null;

            let data = {
                'href': src,
                'type': 'image',
            };

            if (title) {
                data.title = title;
            }
            if (description) {
                data.description = description;
            }

            elements.push(data);
        });


        // Create gallery
        const lightbox = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
            elements: elements,
            preload: false,
            moreLength: 0,
        });


        // Open gallery on click
        $lightboxItems.each(function (index) {
            $(this).on('click', function (event) {
                event.preventDefault();
                lightbox.openAt(index)
            })
        });


    });
});



